<template>
  <div>
    <el-card shadow="never" style="border: 0" class="mt20">
      <div slot="header" class="clearfix">
        <span>{{ getGoodsRankText() }}</span>
        <el-input
          v-model="goodsName"
          :placeholder="getGoodsNamePlaceholder()"
          class="w220 ml20 mr20"
        />
        <el-button @click="goodRank">{{ getSearchText() }}</el-button>
      </div>
      <commonTable
        :tableData="tableData"
        :loading="loading"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :currentPage="currentPage"
        :total="total"
      >
        <template v-slot:table>
          <el-table-column
            align="center"
            type="index"
            :label="getRankText()"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            prop="goodsName"
            :label="getGoodsNameText()"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            prop="sharesNum"
            :label="getSharesNumText()"
            show-overflow-tooltip
          />
          <el-table-column
            align="center"
            prop="salesNum"
            :label="getSalesNumText()"
            show-overflow-tooltip
          />
          <el-table-column align="center" :label="getCustomerPriceText()" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.salesNum == 0
                  ? 0
                  : (scope.row.price / 100 / scope.row.salesNum).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="price" :label="getTotalSalesText()">
            <template slot-scope="scope">
              {{
                scope.row.price == 0 ? 0 : (scope.row.price / 100).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="commissionAmount"
            :label="getCommissionAmountText()"
          >
          </el-table-column>
        </template>
      </commonTable>
    </el-card>
  </div>
</template>

<script>
import { goodRank } from "@/api/distribution";
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      goodsName: "",
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      pageSize2: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  components: {
    commonTable,
  },
  created(){
    this.goodRank()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    /**@method 查询分销商品 */
    async goodRank() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        goodsName: this.goodsName,
      };
      try {
        this.loading = true;
        const result = await goodRank(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.goodRank();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.goodRank();
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getGoodsRankText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销商品排名',
        'zh-TW': '分銷商品排名',
        'en': 'Distribution Product Ranking'
      };
      return textMap[currentLanguage] || '分销商品排名';
    },
    
    getGoodsNamePlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入商品名称',
        'zh-TW': '請輸入商品名稱',
        'en': 'Please enter product name'
      };
      return textMap[currentLanguage] || '请输入商品名称';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getRankText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '排名',
        'zh-TW': '排名',
        'en': 'Rank'
      };
      return textMap[currentLanguage] || '排名';
    },
    
    getGoodsNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '商品名称',
        'zh-TW': '商品名稱',
        'en': 'Product Name'
      };
      return textMap[currentLanguage] || '商品名称';
    },
    
    getSharesNumText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分享次数',
        'zh-TW': '分享次數',
        'en': 'Share Count'
      };
      return textMap[currentLanguage] || '分享次数';
    },
    
    getSalesNumText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '购买次数',
        'zh-TW': '購買次數',
        'en': 'Purchase Count'
      };
      return textMap[currentLanguage] || '购买次数';
    },
    
    getCustomerPriceText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '客单价',
        'zh-TW': '客單價',
        'en': 'Customer Price'
      };
      return textMap[currentLanguage] || '客单价';
    },
    
    getTotalSalesText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '总销售额',
        'zh-TW': '總銷售額',
        'en': 'Total Sales'
      };
      return textMap[currentLanguage] || '总销售额';
    },
    
    getCommissionAmountText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '累计支出佣金',
        'zh-TW': '累計支出佣金',
        'en': 'Total Commission Paid'
      };
      return textMap[currentLanguage] || '累计支出佣金';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>